import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined);

  useEffect(() => {
    const token = localStorage.getItem("ec_token");
    if (!token) {
      setUser(null);
      return;
    }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("ec_token");
        setUser(null);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password, device_token: localStorage.getItem("ec_device") || null, lang: localStorage.getItem("ec_lang") || "es" });
    if (data.otp_required) return data;
    localStorage.setItem("ec_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const verifyOtp = async (pending_token, code, remember_device = false) => {
    const { data } = await api.post("/auth/verify-otp", { pending_token, code, remember_device });
    if (data.device_token) localStorage.setItem("ec_device", data.device_token);
    localStorage.setItem("ec_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", { ...payload, lang: localStorage.getItem("ec_lang") || "es" });
    if (data.pending) return data;
    localStorage.setItem("ec_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    setUser(data);
  };

  const logout = () => {
    localStorage.removeItem("ec_token");
    localStorage.removeItem("ec_tenant");
    setUser(null);
  };

  const setActingTenant = async (tid) => {
    if (tid) localStorage.setItem("ec_tenant", tid); else localStorage.removeItem("ec_tenant");
    await refreshUser();
  };

  return <AuthCtx.Provider value={{ user, login, verifyOtp, register, logout, refreshUser, setActingTenant }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
